import React, { useCallback, useState } from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import Tooltip from '@mui/material/Tooltip';
import { useMutation } from 'react-query';
import PropTypes from 'prop-types';
import useEntriSell from '../../../hooks/useEntriSell';
import { getAppLogin } from '../../../api';
import RequiredBrowserModal from '../home/DashboardQuickLinks/RequiredBrowserModal';
import useBrowserInfo from '../../../hooks/useBrowserInfo';

const TOUR_ID = '603372';

export const GetADomainBtn = ({ title, tooltipTitle, primary }) => {
  const { purchaseDomain } = useEntriSell();

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <Button
        variant={primary ? 'contained' : 'outlined'}
        color={primary ? 'primary' : 'secondary'}
        onClick={purchaseDomain}
        startIcon={<AddIcon />}
      >
        {title}
      </Button>
    </Tooltip>
  );
};

export const OpenDesignAppTourBtn = ({ tourId, title, tooltipTitle, primary = false }) => {
  const [open, setOpenModal] = useState(false);
  const handleClose = () => setOpenModal(false);
  const { designAppSupported, isSafari } = useBrowserInfo();

  const { mutateAsync: openDesignApp } = useMutation((params) => getAppLogin(params), {
    onSuccess: (data) => {
      window.open(`${data.url}&product_tour_id=${tourId}`, isSafari ? '_self' : '_blank');
    },
  });

  const handleOpenDesignApp = useCallback(() => {
    if (designAppSupported) {
      openDesignApp();
    } else {
      setOpenModal(true);
    }
  }, [designAppSupported, openDesignApp]);

  return (
    <>
      <Tooltip title={tooltipTitle} placement="top">
        <Button
          variant={primary ? 'contained' : 'outlined'}
          color={primary ? 'primary' : 'secondary'}
          onClick={handleOpenDesignApp}
          startIcon={<SettingsIcon />}
        >
          {title}
        </Button>
      </Tooltip>
      <RequiredBrowserModal open={open} handleClose={handleClose} />
    </>
  );
};

GetADomainBtn.propTypes = {
  title: PropTypes.string,
  tooltipTitle: PropTypes.string,
  primary: PropTypes.bool,
};

GetADomainBtn.defaultProps = {
  title: 'Get a domain',
  tooltipTitle: 'Get a domain through our trusted provider',
  primary: true,
};

OpenDesignAppTourBtn.propTypes = {
  tourId: PropTypes.string,
  title: PropTypes.string,
  tooltipTitle: PropTypes.string,
  primary: PropTypes.bool,
};

OpenDesignAppTourBtn.defaultProps = {
  tourId: TOUR_ID,
  title: 'Connect Domain',
  tooltipTitle: 'Use a domain you already own',
  primary: false,
};
